export default __webpack_public_path__ + "static/media/Amritalogo.74a0debe.png";